import { render, staticRenderFns } from "./CataloguePost.vue?vue&type=template&id=90031de6&lang=pug&"
import script from "./CataloguePost.vue?vue&type=script&lang=js&"
export * from "./CataloguePost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports